// extracted by mini-css-extract-plugin
export var actionIcon = "_mq-0";